import 'whatwg-fetch';

export default class Api {

    static apiRoot = 'https://www.flunx.de/api';

    static requestPost(path, data, success, error) {
        this.request('POST', path, data, success, error);
    };

    static requestGet(path, success, error) {
        this.request('GET', path, {}, success, error);
    };

    static requestDelete(path, success, error) {
        this.request('DELETE', path, {}, success, error);
    };

    static request(type, path, data, success, error) {
        let config = {
            method: type,
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        };
        if (type !== 'GET') {
            config.body = JSON.stringify(data);
        }
        fetch(Api.apiRoot + path, config).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response
            } else {
                if (typeof(error) === 'function') {
                    error(error);
                }
                throw new Error(response.statusText)
            }
        })
            .then(Api.parseJson)
            .then(success)
            .catch((someError) => {
            })
    };

    static parseJson(data) {
        return data.json();
    }

}

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    Api.apiRoot = 'https://www.flunx.de/dev/api';
}


// WEBPACK FOOTER //
// ./src/Service/Api.js